import { Filter } from "@/shared/lib/filter/filter";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/components/ui/popover";
import { Button } from "@/shared/components/ui/button";
import { Check, ListFilter } from "lucide-react";
import t from "@/lang/lang";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/shared/components/ui/command";
import { cn } from "@/shared/lib/utils";
import { ProcessKindList } from "@/services/backend/processes/types/process-kind";
import { ProcessKind } from "@bitory-gmbh/bsm";

export interface ProcessKindFilterProps {
  filter: Filter<ProcessKind> | undefined;
  onFilterChange: (filter: Filter<ProcessKind>) => void;
  hidden?: boolean;
}

export function ProcessKindFilter({
  filter,
  onFilterChange,
  hidden = false,
}: ProcessKindFilterProps) {
  // This allows us to accept undefined filters,
  // which is common in list requests. This makes
  // it nicer to call the component.
  const filterVal = filter ?? { active: false, values: [] };
  // simplifies some code below
  const currentValues = filterVal.values ?? [];

  if (hidden) {
    return null;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm">
          <ListFilter />
          {t("Art des Vorgangs")}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0" align="start">
        <Command>
          <CommandInput placeholder={t("Art des Vorgangs suchen")} />
          <CommandList>
            <CommandEmpty className="py-3 text-center text-sm">
              {t("Art des Vorgangs nicht gefunden")}
            </CommandEmpty>
            <CommandGroup>
              {ProcessKindList.map((processKind) => (
                <CommandItem
                  key={processKind}
                  value={processKind}
                  onSelect={() => {
                    const values = currentValues.includes(processKind)
                      ? currentValues.filter((v) => v !== processKind)
                      : [...currentValues, processKind];
                    onFilterChange({
                      active: values.length > 0,
                      values,
                    });
                  }}
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      currentValues.includes(processKind)
                        ? "opacity-100"
                        : "opacity-0",
                    )}
                  />
                  {t(processKind)}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
